import '../../../scss/app/register.scss';

document.getElementById('register_firstName').focus();
